export enum BehaviorType {
  Download = 'Download',
  DownloadShare = 'Download and share',
  Share = 'Share',
  ShareFile = 'Share Files',
  ReadOnly = 'Read Only',
  View = 'View',
  Flipbook = 'Flipbook - Share',
  PageExternal = 'External link',
}
export function getBehaviorTypes(): BehaviorType[] {
  return [BehaviorType.Download, BehaviorType.DownloadShare, BehaviorType.Share, BehaviorType.ShareFile, BehaviorType.ReadOnly, BehaviorType.View, BehaviorType.Flipbook, BehaviorType.PageExternal];
}
export function getBehaviorTypeFrom(value: string): BehaviorType | undefined {
  return getBehaviorTypes().find(behavior => behavior === value);
}